<template>
	<fragment>
		
		<div class="filter-selector-controller" :scrollY="scrollY"></div>
	</fragment>

</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import {mapActions,mapGetters} from "vuex";
import {appDict} from "@/features/FeatureHelper";

export default {
	name: "FilterSelectorController",
	
	mixins:[featureMixin],
	props:{
        scrollY: {
			type: Number,
		}
	},
	data(){
		return {
			featurePath: 'filterSortSelector'
		}
	},
	mounted() {
		this.move(this.position);
	},
	
	computed:{
		  ...mapGetters('inlineDrawers', ['isFilterOpen']),
		 ...mapGetters('screen', ['displayMode']),

		isInline(){
			return this.mode === 'inline';
		},
		mode(){
			return this.config.mode;
		},
		position() {
			return this.config.position;
		}
	},
	methods:{
		...mapActions('drawer', ['openSingleInDrawer', 'removeFromDrawer','addToDrawer']),
	move(to, from = null) {
		if (!this.isInline) return;

		const attributes = {
			...this.config.attrs,
			scrollY: this.scrollY
		};
		if (this.isFilterOpen) {
			this.removeFromDrawer({
			id: 'flyerSelector',
			drawer: to
			});
			return;
		}
			if (this.displayMode !== 'desktop') {
				if (from) {
				this.removeFromDrawer({ id: this.featurePath, drawer: from });
				this.removeFromDrawer({ id: 'flyerSelector', drawer: from });
				}
				return;
			}

			if (this.enabled) {
			this.openSingleInDrawer({
			id: this.featurePath,
			component: appDict.inlineFlyerSelector,
			drawer: to,
			attrs: attributes
			});
		}
}


	},
	watch:{
// 	isFilterOpen(val) {
//     if (val) {
//       this.removeFromDrawer({ id: this.featurePath, drawer: this.position });
//     }
//   },
// 		position(to, from) {
// 			this.move(to, from);
// 		},
	}
}
</script>

<style scoped>
	.filter-selector-controller {
		display: none;
	}
</style>
